import { AiHttpService } from './aiHttpService';

export class IndexerService extends AiHttpService {
  constructor() {
    super(); // No endpoint parameter needed anymore
  }

  async indexFiles(force: boolean): Promise<any> {
    try {
      return await this.post({ Force: force }, '/index-files');
    } catch (error) {
      console.error('Error sending indexing request:', error);
      throw error;
    }
  }
} 
